"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Upload = _interopRequireDefault(require("./Upload"));
var Dragger = function Dragger(props) {
  var style = props.style,
    height = props.height;
  return /*#__PURE__*/_react["default"].createElement(_Upload["default"], (0, _extends2["default"])({}, props, {
    type: "drag",
    style: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, style), {}, {
      height: height
    })
  }));
};
var _default = Dragger;
exports["default"] = _default;